import { CoachingPracticeAudio } from '@euler/model/coaching-practice';
import type { LineVoice } from './useScenePlayback';

/** A line's voice from its clips: their levels end to end, and length. */
export function lineVoiceOf(clips: CoachingPracticeAudio[]): LineVoice | null {
  const voiced = clips.filter(x => x.levels && x.durationMs);
  if (!voiced.length) return null;
  return {
    levels: voiced.flatMap(x => x.levels ?? []),
    durationMs: voiced.reduce((sum, x) => sum + (x.durationMs ?? 0), 0),
  };
}
